import { render, staticRenderFns } from "./Customer_point_list.vue?vue&type=template&id=292d799c&scoped=true&"
import script from "./Customer_point_list.vue?vue&type=script&lang=js&"
export * from "./Customer_point_list.vue?vue&type=script&lang=js&"
import style0 from "./Customer_point_list.vue?vue&type=style&index=0&id=292d799c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292d799c",
  null
  
)

export default component.exports